import { z } from "zod";

export const ScheduledControllerResponseSchema = {
  checkExpiredAgendaItems: z.void(),

  checkExpiredTeamMembers: z.void(),

  sendMeetingDateNotifications: z.void(),

  checkExpiredSubmissions: z.void(),
};
